var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var UnexpectedColumnError = /** @class */ (function (_super) {
    __extends(UnexpectedColumnError, _super);
    function UnexpectedColumnError(expectedColumnsCount, rowPos) {
        var _this = _super.call(this, "Expected ".concat(expectedColumnsCount, " columns, but get more in a row #").concat(rowPos)) || this;
        _this.expectedColumnsCount = expectedColumnsCount;
        _this.rowPos = rowPos;
        return _this;
    }
    return UnexpectedColumnError;
}(Error));
export { UnexpectedColumnError };
//# sourceMappingURL=UnexpectedColumnError.js.map